<template>
  <div class="flex mb-12 iframe-form">
    <div class="w-3/5 content-left-panel">
      <iframe-form-content 
        :embedded="false"
        :onClick="saveIFrame"
      />
    </div>
    <div class="w-2/5 pl-10 content-right-panel">
      <div class="flex mb-10 -mx-2" v-if="isEditing">
        <div class="w-1/2 mx-2 modified-date">
          <label class="vs-input--label">Modified on</label>
          <vs-input disabled :value="getCurrentIFrame.modified | dateFormat"></vs-input>
        </div>
        <div class="w-1/2 mx-2 created-date">
          <label class="vs-input--label">Created on</label>
          <vs-input disabled :value="getCurrentIFrame.created | dateFormat"></vs-input>
        </div>
      </div>
      <div class="flex -mx-2 action-buttons">
        <vs-button class="w-full mx-2" color="primary" icon-pack="feather" @click="saveIFrame">Save</vs-button>
      </div>
    </div>
  </div>
</template>

<script>
import iframeFormContent from './forms/IFrameFormContent'
import { mapGetters, mapActions } from 'vuex'

export default {
  components: {
    iframeFormContent
  },
  async created() {
    if (this.$route && this.$route.params.id) {
      if (this.$route.params.id !== this.getCurrentIFrame.id) {
        this.getIFrameToEdit(this.$route.params.id)
      }
    } else {
      this.resetCurrentIFrame()
    }
  },
  computed: {
    ...mapGetters('app', ['getSelectedCompany']),
    ...mapGetters('iframes', ['getCurrentIFrame']),
    isEditing () {
      return this.$route.name === 'edit-iframe'
    }
  },
  methods: {
    ...mapActions('iframes', ['getIFrameAction', 'resetCurrentIFrame', 'saveIFrameToApi']),
    async saveIFrame () {
      try {
        this.$vs.loading()
        
        const response = await this.saveIFrameToApi()

        if (this.$route.name === 'create-iframe') {
          this.$router.push({name: 'edit-iframe', params: {id: response.id}})
        }

        this.$vs.notify({
          title: "Success",
          text: 'IFrame saved',
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "success"
        })
      } catch (error) {
        this.showError(error)
      }
      this.$vs.loading.close()
    },
    async getIFrameToEdit(iframeId) {
      try {
        this.$vs.loading();
        await this.getIFrameAction({iframeId: iframeId})
        if (this.getCurrentIFrame.company !== this.getSelectedCompany) {
          // ToDo: Possible bug, we could still be in create
          this.$router.push({ name: "create-iframe" });
          this.$vs.notify({
            title: "Warning",
            text: 'IFrame you were editing belongs to a different company',
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "warning"
          });
        }
        this.$vs.loading.close();
      } catch (error) {
        this.showError(error)
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    if (to.name === "create-iframe") {
      this.resetCurrentIFrame();
    }
    if (to.name === 'edit-iframe') {
      this.getIFrameToEdit(to.params.id)
    }
    next();
  }
}
</script>
<style lang="scss" scoped>

</style>